import React from 'react';
import BrandingSettingsManager from 'components/UI/adminPage/brandingSettings/BrandingSettingsManager';

const BrandingSettingsPage = () => {
  return <BrandingSettingsManager />;
};

export default BrandingSettingsPage;

